import { render } from "./modelthree.vue?vue&type=template&id=3eb61740"
import script from "./modelthree.vue?vue&type=script&lang=js"
export * from "./modelthree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__